import Reflux from 'reflux';

const FieldQuickValuesActions = Reflux.createActions({
  get: { asyncResult: true },
  getHistogram: { asyncResult: true },
});

export default FieldQuickValuesActions;



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/graylog-project-cli-release/.repos/graylog2-server/graylog2-web-interface/src/actions/field-analyzers/FieldQuickValuesActions.js